import { IWPGBlock } from 'react-gutenberg'

export const IWPGBlockAttributesCompare = (prevProps: Readonly<IWPGBlock>, nextProps: Readonly<IWPGBlock>) =>
  JSON.stringify(prevProps.attrs) === JSON.stringify(nextProps.attrs)
